export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export * from './graphql-operations';
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type AmapiDeviceManagementOutput = DeviceManagementOutput & {
  __typename?: 'AMAPIDeviceManagementOutput';
  lastContactTime?: Maybe<Scalars['DateTime']['output']>;
  lastPolicySyncTime?: Maybe<Scalars['DateTime']['output']>;
  nameTail: Scalars['String']['output'];
  provider: MdmProvider;
  slug?: Maybe<Scalars['String']['output']>;
};

export enum AccessLevel {
  MANAGER = 'MANAGER',
  MEMBER = 'MEMBER'
}

export enum AcquisitionChannel {
  ADVERTISEMENT = 'ADVERTISEMENT',
  B2B = 'B2B',
  B2B2C = 'B2B2C',
  CUSTOMER_RECOMENDATION = 'CUSTOMER_RECOMENDATION',
  FACEBOOK = 'FACEBOOK',
  GOOGLE_SEARCH = 'GOOGLE_SEARCH',
  INSTAGRAM = 'INSTAGRAM',
  NEWSPAPER = 'NEWSPAPER',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  OTHER = 'OTHER',
  OTHER_PERSON_RECOMENDATION = 'OTHER_PERSON_RECOMENDATION',
  PHYSICAL_STORE = 'PHYSICAL_STORE',
  RADIO = 'RADIO',
  TELEVISION = 'TELEVISION',
  TIKTOK = 'TIKTOK',
  YOUTUBE = 'YOUTUBE'
}

export type ActivateSimInput = {
  iccid: SimIccidInput;
  phoneNumber: PhoneNumberInput;
};

export type AddChangeCommentInput = {
  changeId: ChangeIdInput;
  content: CommentContentInput;
};

export type AddDirectDebitInput = {
  iban: IbanInput;
  paymentId: PaymentIdInput;
};

export type AddOrderCommentInput = {
  content: CommentContentInput;
  orderId: OrderIdInput;
};

export type AddShipmentCommentInput = {
  content: CommentContentInput;
  shipmentId: ShipmentIdInput;
};

export type AddSubscriptionCommentInput = {
  content: CommentContentInput;
  subscriptionId: SubscriptionIdInput;
};

export enum AppDeliveryMode {
  MANAGED = 'MANAGED',
  SELF_SERVICE = 'SELF_SERVICE'
}

export enum AppInstallType {
  BLOCKED = 'BLOCKED',
  KIOSK = 'KIOSK',
  OPTIONAL = 'OPTIONAL',
  REQUIRED = 'REQUIRED',
  UNKNOWN = 'UNKNOWN'
}

export type AssignDeviceChangeInput = {
  changeId: ChangeIdInput;
  deviceIMEI: DeviceImeiInput;
};

export type AssignExternalAppInput = {
  grandpaUUID: GrandpaUuidInput;
  packageName: PackageNameInput;
};

export type AssignExternalAppOutput = {
  __typename?: 'AssignExternalAppOutput';
  assignedApps: Array<GrandpaExternalAppOutput>;
  deliveryMode: AppDeliveryMode;
  isAlreadyInstalled?: Maybe<Scalars['Boolean']['output']>;
};

export type AssignOrderInput = {
  deviceIMEI: DeviceImeiInput;
  orderId: OrderIdInput;
  simICCID?: InputMaybe<SimIccidInput>;
};

export type AssignSimChangeInput = {
  changeId: ChangeIdInput;
  simICCID: SimIccidInput;
};

export type AssignSimShipmentInput = {
  shipmentId: ShipmentIdInput;
  simICCID: SimIccidInput;
};

export type AutoCallMosCommandInput = {
  phoneNumber: PhoneNumberInput;
};

export enum BatteryHealthFlag {
  BROKEN_CHARGE = 'BROKEN_CHARGE',
  CRITICAL_AUTONOMY = 'CRITICAL_AUTONOMY',
  LOW_AUTONOMY = 'LOW_AUTONOMY',
  SLOW_CHARGE = 'SLOW_CHARGE'
}

export type BatteryHealthOutput = {
  __typename?: 'BatteryHealthOutput';
  charge?: Maybe<BatteryPaceOutput>;
  drain?: Maybe<BatteryPaceOutput>;
  flags: Array<BatteryHealthFlag>;
  status: BatteryHealthStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum BatteryHealthStatus {
  CRITICAL = 'CRITICAL',
  NO_DATA = 'NO_DATA',
  OK = 'OK',
  REVIEW = 'REVIEW'
}

export type BatteryPaceOutput = {
  __typename?: 'BatteryPaceOutput';
  minutesPerPercent: Scalars['Float']['output'];
  samples: Scalars['Int']['output'];
};

export type BoxIdInput = {
  value: Scalars['String']['input'];
};

export type BoxOutput = {
  __typename?: 'BoxOutput';
  contactName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  subscriptions: Array<SubscriptionOutput>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BusinessNameInput = {
  value: Scalars['String']['input'];
};

export type CifInput = {
  value: Scalars['String']['input'];
};

export type CancelOrderInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  orderId: OrderIdInput;
  refundStrategy?: InputMaybe<RefundStrategy>;
};

export type CancelWithoutRequestInput = {
  deviceEvaluation: DeviceEvaluation;
  /** Only for dev purposes. Cancels subscription without resetting the device. */
  disableDeviceReset?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only for dev purposes. Cancels subscription without cancelling the SIM */
  disableSimCancellation?: InputMaybe<Scalars['Boolean']['input']>;
  keepNumber?: InputMaybe<Scalars['Boolean']['input']>;
  reason: SubscriptionCancellationReason;
  reasonDetails?: InputMaybe<Scalars['String']['input']>;
  refundStrategy?: InputMaybe<RefundStrategy>;
  subscriptionId: SubscriptionIdInput;
};

export type CancellationFilterCriteriaInput = {
  orderBy?: InputMaybe<OrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<CancellationStatus>>;
};

export type CancellationIdInput = {
  value: Scalars['String']['input'];
};

export type CancellationIdentifierInput =
  { id: CancellationIdInput; };

export type CancellationOutput = {
  __typename?: 'CancellationOutput';
  deviceEvaluation?: Maybe<DeviceEvaluation>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  keepNumber?: Maybe<Scalars['Boolean']['output']>;
  lastDevice?: Maybe<DeviceOutput>;
  lastSim?: Maybe<SimOutput>;
  reason?: Maybe<CancellationReason>;
  reasonDetails?: Maybe<Scalars['String']['output']>;
  requestedAt: Scalars['DateTime']['output'];
  requestedBy?: Maybe<MaximilianerOutput>;
  returnDelivery?: Maybe<DeliveryOutput>;
  status: CancellationStatus;
  subscription: SubscriptionOutput;
};

export type CancellationPaginatedOutput = {
  __typename?: 'CancellationPaginatedOutput';
  total: Scalars['Float']['output'];
  values: Array<CancellationOutput>;
};

export enum CancellationReason {
  EXITUS = 'EXITUS',
  FRAUD = 'FRAUD',
  FRAUDULENT_ORDER = 'FRAUDULENT_ORDER',
  HEALTH_DETERIORATION = 'HEALTH_DETERIORATION',
  INSUFFICIENT_VOLUME = 'INSUFFICIENT_VOLUME',
  LACK_OF_MOBILE_FUNTIONALITIES = 'LACK_OF_MOBILE_FUNTIONALITIES',
  MOBILE_MALFUNCTION = 'MOBILE_MALFUNCTION',
  MOBILE_WEIGHT_DIFFICULTY = 'MOBILE_WEIGHT_DIFFICULTY',
  ORDER_CANCELLED = 'ORDER_CANCELLED',
  OTHER = 'OTHER',
  PILOT_ENDED = 'PILOT_ENDED',
  PILOT_TO_CLIENT = 'PILOT_TO_CLIENT',
  TOUCHSCREEN_DIFFICULTY = 'TOUCHSCREEN_DIFFICULTY',
  USER_REFUSAL = 'USER_REFUSAL'
}

export enum CancellationStatus {
  COMPLETED = 'COMPLETED',
  REQUESTED = 'REQUESTED'
}

export type CancellationsStatsOutput = {
  __typename?: 'CancellationsStatsOutput';
  averageLifetimeBeforeCancellation: Scalars['Float']['output'];
  byReason: Scalars['JSON']['output'];
  currentMonthProjection: Scalars['Float']['output'];
  daily: Scalars['JSON']['output'];
  dailyAverageLast14Days: Scalars['Float']['output'];
  deviceReturnRate: Scalars['Float']['output'];
  evolution: Scalars['JSON']['output'];
  pendingCancellations: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export enum CardBrand {
  AMEX = 'AMEX',
  MASTERCARD = 'MASTERCARD',
  OTHER = 'OTHER',
  VISA = 'VISA'
}

export type CarrierPortabilityIdInput = {
  value: Scalars['String']['input'];
};

export type ChangeFilterCriteriaInput = {
  orderBy?: InputMaybe<OrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<ChangeStatus>>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ChangeType>;
};

export type ChangeIdInput = {
  value: Scalars['String']['input'];
};

export type ChangeIdListInput = {
  values: Array<ChangeIdInput>;
};

export type ChangeIdentifierInput =
  { id: ChangeIdInput; };

export type ChangeOutput = {
  comments: Array<CommentOutput>;
  createdAt: Scalars['DateTime']['output'];
  delivery: DeliveryOutput;
  id: Scalars['String']['output'];
  previousChecks?: Maybe<Scalars['JSON']['output']>;
  reason: ChangeReason;
  requestedBy?: Maybe<MaximilianerOutput>;
  spares: Array<Spares>;
  status: ChangeStatus;
  subscription: SubscriptionOutput;
  type: ChangeType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum ChangeReason {
  BROKEN = 'BROKEN',
  BROKEN_MIC = 'BROKEN_MIC',
  BROKEN_SCREEN = 'BROKEN_SCREEN',
  CONNECTIVITY_PROBLEM = 'CONNECTIVITY_PROBLEM',
  COVERAGE_ISSUES = 'COVERAGE_ISSUES',
  DAMAGED_CHARGING_PORT = 'DAMAGED_CHARGING_PORT',
  DEVICE_USAGE_SIGNS = 'DEVICE_USAGE_SIGNS',
  HARD_RESET = 'HARD_RESET',
  LOST = 'LOST',
  LOST_OR_STOLEN = 'LOST_OR_STOLEN',
  OTHER = 'OTHER',
  SHORT_BATTERY_LIFE = 'SHORT_BATTERY_LIFE',
  SLOW_CHARGING = 'SLOW_CHARGING',
  SWOLLEN_BATTERY = 'SWOLLEN_BATTERY',
  VOLUME_ISSUES = 'VOLUME_ISSUES',
  WANTS_NEW_NUMBER = 'WANTS_NEW_NUMBER',
  WANTS_PORTABILITY = 'WANTS_PORTABILITY',
  WHITE_QR = 'WHITE_QR'
}

export enum ChangeStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  REQUESTED = 'REQUESTED',
  RETURN_PENDING = 'RETURN_PENDING',
  SHIPPED = 'SHIPPED'
}

export enum ChangeType {
  DEVICE = 'DEVICE',
  SIM = 'SIM'
}

export type ChangeUnionOutput = DeviceChangeOutput | SimChangeOutput;

export type ChangeUnionPaginatedOutput = {
  __typename?: 'ChangeUnionPaginatedOutput';
  total: Scalars['Float']['output'];
  values: Array<ChangeUnionOutput>;
};

export type CommentContentInput = {
  value: Scalars['String']['input'];
};

export type CommentIdInput = {
  value: Scalars['String']['input'];
};

export type CommentOutput = {
  __typename?: 'CommentOutput';
  author?: Maybe<MaximilianerOutput>;
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
};

export type CompanyDetailsInput = {
  businessName: BusinessNameInput;
  cif: CifInput;
  email: EmailInput;
  firstName: NameInput;
  lastName: NameInput;
  phoneNumber: PhoneNumberInput;
};

export type ConditionsFilterCriteriaInput = {
  orderBy?: InputMaybe<OrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  pricing?: InputMaybe<ConditionsPricing>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};

export type ConditionsIdInput = {
  value: Scalars['String']['input'];
};

export type ConditionsOutput = {
  __typename?: 'ConditionsOutput';
  id: Scalars['String']['output'];
  includesSim: Scalars['Boolean']['output'];
  isSwitchable: Scalars['Boolean']['output'];
  maxActiveMonths?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export enum ConditionsPricing {
  FREE = 'FREE',
  PAID = 'PAID'
}

export type ConditionsSwitchOutput = {
  __typename?: 'ConditionsSwitchOutput';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  newConditions: ConditionsOutput;
  newConditionsId: Scalars['String']['output'];
  previousConditions: ConditionsOutput;
  previousConditionsId: Scalars['String']['output'];
  requestedBy?: Maybe<MaximilianerOutput>;
  status: ConditionsSwitchStatus;
  subscriptionId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum ConditionsSwitchStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING'
}

export type ConfirmCancellationInput = {
  deviceEvaluation: DeviceEvaluation;
  /** Only for dev purposes. Cancels subscription without resetting the device. */
  disableDeviceReset?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only for dev purposes. Cancels subscription without cancelling the SIM */
  disableSimCancellation?: InputMaybe<Scalars['Boolean']['input']>;
  refundStrategy?: InputMaybe<RefundStrategy>;
  subscriptionId: SubscriptionIdInput;
};

export type ContactDataInUseIssueOutput = {
  __typename?: 'ContactDataInUseIssueOutput';
  documentNumber: Scalars['String']['output'];
  fields: Array<SuspicionField>;
  kind: OrderHoldIssueKind;
  name: Scalars['String']['output'];
  personId: Scalars['String']['output'];
};

export enum CountryCode {
  AD = 'AD',
  AE = 'AE',
  AF = 'AF',
  AG = 'AG',
  AI = 'AI',
  AL = 'AL',
  AM = 'AM',
  AO = 'AO',
  AQ = 'AQ',
  AR = 'AR',
  AS = 'AS',
  AT = 'AT',
  AU = 'AU',
  AW = 'AW',
  AX = 'AX',
  AZ = 'AZ',
  BA = 'BA',
  BB = 'BB',
  BD = 'BD',
  BE = 'BE',
  BF = 'BF',
  BG = 'BG',
  BH = 'BH',
  BI = 'BI',
  BJ = 'BJ',
  BL = 'BL',
  BM = 'BM',
  BN = 'BN',
  BO = 'BO',
  BQ = 'BQ',
  BR = 'BR',
  BS = 'BS',
  BT = 'BT',
  BV = 'BV',
  BW = 'BW',
  BY = 'BY',
  BZ = 'BZ',
  CA = 'CA',
  CC = 'CC',
  CD = 'CD',
  CF = 'CF',
  CG = 'CG',
  CH = 'CH',
  CI = 'CI',
  CK = 'CK',
  CL = 'CL',
  CM = 'CM',
  CN = 'CN',
  CO = 'CO',
  CR = 'CR',
  CU = 'CU',
  CV = 'CV',
  CW = 'CW',
  CX = 'CX',
  CY = 'CY',
  CZ = 'CZ',
  DE = 'DE',
  DJ = 'DJ',
  DK = 'DK',
  DM = 'DM',
  DO = 'DO',
  DZ = 'DZ',
  EC = 'EC',
  EE = 'EE',
  EG = 'EG',
  EH = 'EH',
  ER = 'ER',
  ES = 'ES',
  ET = 'ET',
  FI = 'FI',
  FJ = 'FJ',
  FK = 'FK',
  FM = 'FM',
  FO = 'FO',
  FR = 'FR',
  GA = 'GA',
  GB = 'GB',
  GD = 'GD',
  GE = 'GE',
  GF = 'GF',
  GG = 'GG',
  GH = 'GH',
  GI = 'GI',
  GL = 'GL',
  GM = 'GM',
  GN = 'GN',
  GP = 'GP',
  GQ = 'GQ',
  GR = 'GR',
  GS = 'GS',
  GT = 'GT',
  GU = 'GU',
  GW = 'GW',
  GY = 'GY',
  HK = 'HK',
  HM = 'HM',
  HN = 'HN',
  HR = 'HR',
  HT = 'HT',
  HU = 'HU',
  ID = 'ID',
  IE = 'IE',
  IL = 'IL',
  IM = 'IM',
  IN = 'IN',
  IO = 'IO',
  IQ = 'IQ',
  IR = 'IR',
  IS = 'IS',
  IT = 'IT',
  JE = 'JE',
  JM = 'JM',
  JO = 'JO',
  JP = 'JP',
  KE = 'KE',
  KG = 'KG',
  KH = 'KH',
  KI = 'KI',
  KM = 'KM',
  KN = 'KN',
  KP = 'KP',
  KR = 'KR',
  KW = 'KW',
  KY = 'KY',
  KZ = 'KZ',
  LA = 'LA',
  LB = 'LB',
  LC = 'LC',
  LI = 'LI',
  LK = 'LK',
  LR = 'LR',
  LS = 'LS',
  LT = 'LT',
  LU = 'LU',
  LV = 'LV',
  LY = 'LY',
  MA = 'MA',
  MC = 'MC',
  MD = 'MD',
  ME = 'ME',
  MF = 'MF',
  MG = 'MG',
  MH = 'MH',
  MK = 'MK',
  ML = 'ML',
  MM = 'MM',
  MN = 'MN',
  MO = 'MO',
  MP = 'MP',
  MQ = 'MQ',
  MR = 'MR',
  MS = 'MS',
  MT = 'MT',
  MU = 'MU',
  MV = 'MV',
  MW = 'MW',
  MX = 'MX',
  MY = 'MY',
  MZ = 'MZ',
  NA = 'NA',
  NC = 'NC',
  NE = 'NE',
  NF = 'NF',
  NG = 'NG',
  NI = 'NI',
  NL = 'NL',
  NO = 'NO',
  NP = 'NP',
  NR = 'NR',
  NU = 'NU',
  NZ = 'NZ',
  OM = 'OM',
  PA = 'PA',
  PE = 'PE',
  PF = 'PF',
  PG = 'PG',
  PH = 'PH',
  PK = 'PK',
  PL = 'PL',
  PM = 'PM',
  PN = 'PN',
  PR = 'PR',
  PS = 'PS',
  PT = 'PT',
  PW = 'PW',
  PY = 'PY',
  QA = 'QA',
  RE = 'RE',
  RO = 'RO',
  RS = 'RS',
  RU = 'RU',
  RW = 'RW',
  SA = 'SA',
  SB = 'SB',
  SC = 'SC',
  SD = 'SD',
  SE = 'SE',
  SG = 'SG',
  SH = 'SH',
  SI = 'SI',
  SJ = 'SJ',
  SK = 'SK',
  SL = 'SL',
  SM = 'SM',
  SN = 'SN',
  SO = 'SO',
  SR = 'SR',
  SS = 'SS',
  ST = 'ST',
  SV = 'SV',
  SX = 'SX',
  SY = 'SY',
  SZ = 'SZ',
  TC = 'TC',
  TD = 'TD',
  TF = 'TF',
  TG = 'TG',
  TH = 'TH',
  TJ = 'TJ',
  TK = 'TK',
  TL = 'TL',
  TM = 'TM',
  TN = 'TN',
  TO = 'TO',
  TR = 'TR',
  TT = 'TT',
  TV = 'TV',
  TW = 'TW',
  TZ = 'TZ',
  UA = 'UA',
  UG = 'UG',
  UM = 'UM',
  US = 'US',
  UY = 'UY',
  UZ = 'UZ',
  VA = 'VA',
  VC = 'VC',
  VE = 'VE',
  VG = 'VG',
  VI = 'VI',
  VN = 'VN',
  VU = 'VU',
  WF = 'WF',
  WS = 'WS',
  YE = 'YE',
  YT = 'YT',
  ZA = 'ZA',
  ZM = 'ZM',
  ZW = 'ZW'
}

export type CreateBoxInput = {
  address: PostalAddressInput;
  boxName: Scalars['String']['input'];
  conditionsId: ConditionsIdInput;
  contactName: NameInput;
  email: EmailInput;
  grandpaNickname: Scalars['String']['input'];
  identificationNumber: DocumentNumberInput;
  paymentDetails: NonStripePaymentDetailsInput;
  phoneNumber: PhoneNumberInput;
  sendCustomerNotification: Scalars['Boolean']['input'];
  sendTeamNotification: Scalars['Boolean']['input'];
  subscriptionQuantity: Scalars['Float']['input'];
};

export type CreateExternalAppInput = {
  iconPath: Scalars['String']['input'];
  name: Scalars['String']['input'];
  packageName: PackageNameInput;
  subtitle: Scalars['String']['input'];
};

export type CreatePortabilityInput = {
  donorCarrier: DonorCarrier;
  holderDocument: HolderDocumentInput;
  holderFullName: NameInput;
  planType: PortabilityPlanType;
  portingPhoneNumber: PhoneNumberInput;
  prepaidSimICCID?: InputMaybe<SimIccidInput>;
  schedule: PortabilitySchedule;
  subscriptionId: SubscriptionIdInput;
};

export type DataConsumptionOutput = {
  __typename?: 'DataConsumptionOutput';
  availableDataInGB: Scalars['Float']['output'];
  consumedDataInGB: Scalars['Float']['output'];
};

export type DataPlanOutput = {
  __typename?: 'DataPlanOutput';
  carrier: Scalars['String']['output'];
  gb: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  internationalMinutes: Scalars['Int']['output'];
  nationalMinutes: Scalars['Int']['output'];
  sims: Array<SimOutput>;
};

export type DeliveryIdInput = {
  value: Scalars['String']['input'];
};

export type DeliveryIdListInput = {
  values: Array<DeliveryIdInput>;
};

export type DeliveryModificationParamsInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountryCode>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstLine?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  secondLine?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type DeliveryOutput = {
  __typename?: 'DeliveryOutput';
  address: PostalAddressOutput;
  createdAt: Scalars['DateTime']['output'];
  deliveredAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  expedition?: Maybe<ExpeditionOutput>;
  id: Scalars['String']['output'];
  isUrgent: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  status: DeliveryStatus;
  type: DeliveryType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum DeliveryStatus {
  CANCELLED = 'CANCELLED',
  CONFIRMED = 'CONFIRMED',
  DELIVERED = 'DELIVERED',
  PENDING = 'PENDING',
  REQUIRES_MANUAL_ACTION = 'REQUIRES_MANUAL_ACTION'
}

export enum DeliveryType {
  COURIER = 'COURIER',
  CUSTOMER_RETURN = 'CUSTOMER_RETURN',
  PHYSICAL_STORE = 'PHYSICAL_STORE',
  PICK_UP = 'PICK_UP'
}

export type DeregisterExternalAppInput = {
  force?: Scalars['Boolean']['input'];
  packageName: PackageNameInput;
};

export type DeviceChangeFilterCriteriaInput = {
  newDeviceIMEI?: InputMaybe<Scalars['String']['input']>;
  oldDeviceIMEI?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  reason?: InputMaybe<Array<DeviceChangeReason>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<ChangeStatus>>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ChangeType>;
};

export type DeviceChangeOutput = ChangeOutput & {
  __typename?: 'DeviceChangeOutput';
  comments: Array<CommentOutput>;
  createdAt: Scalars['DateTime']['output'];
  delivery: DeliveryOutput;
  id: Scalars['String']['output'];
  newDevice?: Maybe<DeviceOutput>;
  oldDevice: DeviceOutput;
  previousChecks?: Maybe<Scalars['JSON']['output']>;
  reason: ChangeReason;
  requestedBy?: Maybe<MaximilianerOutput>;
  requiredAction: DeviceChangeRequiredAction;
  returnDelivery?: Maybe<DeliveryOutput>;
  spares: Array<Spares>;
  status: ChangeStatus;
  subscription: SubscriptionOutput;
  type: ChangeType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DeviceChangePaginatedOutput = {
  __typename?: 'DeviceChangePaginatedOutput';
  total: Scalars['Float']['output'];
  values: Array<DeviceChangeOutput>;
};

export enum DeviceChangeReason {
  BROKEN_MIC = 'BROKEN_MIC',
  BROKEN_SCREEN = 'BROKEN_SCREEN',
  CONNECTIVITY_PROBLEM = 'CONNECTIVITY_PROBLEM',
  DAMAGED_CHARGING_PORT = 'DAMAGED_CHARGING_PORT',
  DEVICE_USAGE_SIGNS = 'DEVICE_USAGE_SIGNS',
  HARD_RESET = 'HARD_RESET',
  LOST = 'LOST',
  OTHER = 'OTHER',
  SHORT_BATTERY_LIFE = 'SHORT_BATTERY_LIFE',
  SLOW_CHARGING = 'SLOW_CHARGING',
  SWOLLEN_BATTERY = 'SWOLLEN_BATTERY',
  VOLUME_ISSUES = 'VOLUME_ISSUES',
  WHITE_QR = 'WHITE_QR'
}

export enum DeviceChangeRequiredAction {
  ENGINEERING_ANALYSIS = 'ENGINEERING_ANALYSIS',
  REGULAR_ANALYSIS = 'REGULAR_ANALYSIS'
}

export enum DeviceDeploymentEndReason {
  CANCELLATION = 'CANCELLATION',
  DEVICE_CHANGE = 'DEVICE_CHANGE'
}

export type DeviceDeploymentOutput = {
  __typename?: 'DeviceDeploymentOutput';
  days: Scalars['Int']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  endReason?: Maybe<DeviceDeploymentEndReason>;
  entryDate: Scalars['DateTime']['output'];
  subscription: SubscriptionOutput;
};

export type DeviceDeploymentSummaryOutput = {
  __typename?: 'DeviceDeploymentSummaryOutput';
  deployments: Array<DeviceDeploymentOutput>;
  deviceIMEI: Scalars['String']['output'];
  totalDays: Scalars['Int']['output'];
  totalSubscriptions: Scalars['Int']['output'];
};

export enum DeviceEvaluation {
  LOST = 'LOST',
  NOT_SENT = 'NOT_SENT',
  NOT_USABLE = 'NOT_USABLE',
  OK = 'OK',
  REQUIRES_ANALISYS = 'REQUIRES_ANALISYS'
}

export type DeviceFilterCriteriaInput = {
  batteryHealthStatus?: InputMaybe<Array<BatteryHealthStatus>>;
  mdmProvider?: InputMaybe<Array<MdmProvider>>;
  orderBy?: InputMaybe<OrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<DeviceStatus>>;
};

export type DeviceImeiInput = {
  value: Scalars['String']['input'];
};

export type DeviceImeiListInput = {
  values: Array<DeviceImeiInput>;
};

export type DeviceIdentifierInput =
  { imei: DeviceImeiInput; uuid?: never; }
  |  { imei?: never; uuid: DeviceUuidInput; };

export type DeviceManagementOutput = {
  lastContactTime?: Maybe<Scalars['DateTime']['output']>;
  provider: MdmProvider;
};

export type DeviceModelOutput = {
  __typename?: 'DeviceModelOutput';
  brand: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tac: Scalars['String']['output'];
};

export type DeviceOutput = {
  __typename?: 'DeviceOutput';
  batteryHealth?: Maybe<BatteryHealthOutput>;
  deploymentSummary: DeviceDeploymentSummaryOutput;
  developmentAlias?: Maybe<Scalars['String']['output']>;
  imei: Scalars['String']['output'];
  management?: Maybe<DeviceManagementOutput>;
  model: DeviceModelOutput;
  mos?: Maybe<MosOutput>;
  mosInstallationStatus?: Maybe<MosInstallationStatusOutput>;
  registeredAt: Scalars['DateTime']['output'];
  relatedDeviceChanges: Array<DeviceChangeOutput>;
  status: DeviceStatus;
  subscription?: Maybe<SubscriptionOutput>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DevicePaginatedOutput = {
  __typename?: 'DevicePaginatedOutput';
  total: Scalars['Float']['output'];
  values: Array<DeviceOutput>;
};

export enum DeviceStatus {
  DEVELOPMENT = 'DEVELOPMENT',
  ENROLLED = 'ENROLLED',
  IN_SETUP = 'IN_SETUP',
  LOCKED_FOR_CHANGE = 'LOCKED_FOR_CHANGE',
  LOST = 'LOST',
  NEW = 'NEW',
  NOT_USABLE = 'NOT_USABLE',
  PENDING_ANALYSIS = 'PENDING_ANALYSIS',
  PENDING_ENGINEERING_ANALYSIS = 'PENDING_ENGINEERING_ANALYSIS'
}

export type DeviceUuidInput = {
  value: Scalars['String']['input'];
};

export type DevicesStatsOutput = {
  __typename?: 'DevicesStatsOutput';
  mdm: Scalars['JSON']['output'];
  models: Scalars['JSON']['output'];
  occupation: Scalars['Float']['output'];
  ready: Scalars['Float']['output'];
  status: Scalars['JSON']['output'];
  total: Scalars['Float']['output'];
};

export type DiscardOrderHoldInput = {
  id: OrderHoldIdInput;
  reason: OrderHoldDiscardReason;
  refundStrategy: RefundStrategy;
};

export type DocumentNumberInput = {
  value: Scalars['String']['input'];
};

export enum DocumentType {
  CIF = 'CIF',
  NIE = 'NIE',
  NIF = 'NIF',
  PASSPORT = 'PASSPORT',
  UNKNOWN = 'UNKNOWN'
}

export enum DonorCarrier {
  ADAMO = 'ADAMO',
  AGENCIA_TRIBUTARIA = 'AGENCIA_TRIBUTARIA',
  AIRENETWORKS = 'AIRENETWORKS',
  ALAI_SECURE = 'ALAI_SECURE',
  ALTECOM = 'ALTECOM',
  ATUAXANELA = 'ATUAXANELA',
  AUREA_MOTRIZ = 'AUREA_MOTRIZ',
  AVANZA_FIBRA = 'AVANZA_FIBRA',
  AVATEL = 'AVATEL',
  BARCA_MOBILE = 'BARCA_MOBILE',
  BUTIK = 'BUTIK',
  CABLE_WORLD = 'CABLE_WORLD',
  CITELIA = 'CITELIA',
  CUBEMOVIL_FMVNO = 'CUBEMOVIL_FMVNO',
  CUBE_MOVIL = 'CUBE_MOVIL',
  DEFENSA = 'DEFENSA',
  DIGI_SPAIN_TELECOM = 'DIGI_SPAIN_TELECOM',
  DRAGONET_COMUNICACIONES = 'DRAGONET_COMUNICACIONES',
  EMBOU = 'EMBOU',
  ERTZAINTZA = 'ERTZAINTZA',
  ESDOMO_TELECOM = 'ESDOMO_TELECOM',
  ESDOMO_TELECOM_2_0 = 'ESDOMO_TELECOM_2_0',
  EUSKALTEL = 'EUSKALTEL',
  EVOLUTIO = 'EVOLUTIO',
  FIBRITEL = 'FIBRITEL',
  FINETWORK = 'FINETWORK',
  FLEXIMOVIL = 'FLEXIMOVIL',
  FOOTBALLERISTA = 'FOOTBALLERISTA',
  GIGA = 'GIGA',
  GLOBAL_CARRIER = 'GLOBAL_CARRIER',
  GLOFERA = 'GLOFERA',
  GNET = 'GNET',
  GRUPALIA_INTERNET = 'GRUPALIA_INTERNET',
  GUARDIA_CIVIL = 'GUARDIA_CIVIL',
  GUUK = 'GUUK',
  HITS_MOBILE = 'HITS_MOBILE',
  HI_RELIEF = 'HI_RELIEF',
  IBERSONTEL = 'IBERSONTEL',
  INTELECTIA = 'INTELECTIA',
  JAZZTEL = 'JAZZTEL',
  JETNET = 'JETNET',
  JETNET5G = 'JETNET5G',
  JETNET_5G_2_0 = 'JETNET_5G_2_0',
  JOI_MOBILE = 'JOI_MOBILE',
  LEBARA_MOVIL = 'LEBARA_MOVIL',
  LEGOS = 'LEGOS',
  LEMONVIL = 'LEMONVIL',
  LLAMAYA_GMM = 'LLAMAYA_GMM',
  LOBSTER = 'LOBSTER',
  LOWI = 'LOWI',
  LYCAMOBILE = 'LYCAMOBILE',
  MASMOVIL = 'MASMOVIL',
  MAS_IP = 'MAS_IP',
  MIMONKEY = 'MIMONKEY',
  MOMOFONE = 'MOMOFONE',
  MOSSOS = 'MOSSOS',
  MOVISTAR = 'MOVISTAR',
  NADUNET = 'NADUNET',
  NEOTEL = 'NEOTEL',
  NEO_SKY_2002 = 'NEO_SKY_2002',
  NEO_SKY_2002_SA = 'NEO_SKY_2002_SA',
  NETLLAR = 'NETLLAR',
  NORVOZ = 'NORVOZ',
  O2 = 'O2',
  ONITI = 'ONITI',
  ONMOVIL = 'ONMOVIL',
  ONSICOM = 'ONSICOM',
  OPENCABLE_TELECOMUNICACIONES = 'OPENCABLE_TELECOMUNICACIONES',
  OPERADORS_CAT = 'OPERADORS_CAT',
  ORANGE = 'ORANGE',
  PARLEM_TELECOM = 'PARLEM_TELECOM',
  PEPEPHONE_3_0 = 'PEPEPHONE_3_0',
  POLICIA_NACIONAL = 'POLICIA_NACIONAL',
  PTV_TELECOM_4G = 'PTV_TELECOM_4G',
  PTV_TELECOM_5G = 'PTV_TELECOM_5G',
  QUATTRE = 'QUATTRE',
  QUATTRE_2_0 = 'QUATTRE_2_0',
  R_CABLE_Y_TELECOMUNICACIONES = 'R_CABLE_Y_TELECOMUNICACIONES',
  SARENET = 'SARENET',
  SARENETOMV = 'SARENETOMV',
  SERVICIOS_INTEGRADOS_7P = 'SERVICIOS_INTEGRADOS_7P',
  SEVEN_PLAY = 'SEVEN_PLAY',
  SEWAN = 'SEWAN',
  SILBO = 'SILBO',
  SILBO_FS = 'SILBO_FS',
  SIMYO = 'SIMYO',
  SIPTIZE = 'SIPTIZE',
  SISNET = 'SISNET',
  SITELGCAI = 'SITELGCAI',
  SUMA = 'SUMA',
  SUOP = 'SUOP',
  SYMA = 'SYMA',
  TELECABLE = 'TELECABLE',
  TELECOM = 'TELECOM',
  TELEFONICA_TECH_AIOT = 'TELEFONICA_TECH_AIOT',
  TELEPORTE = 'TELEPORTE',
  TELFY = 'TELFY',
  TELFY_5G = 'TELFY_5G',
  TELSOME = 'TELSOME',
  TELYRA_TELECOM = 'TELYRA_TELECOM',
  THE_TELECOM_BOUTIQUE = 'THE_TELECOM_BOUTIQUE',
  TRUPHONE = 'TRUPHONE',
  UNIDAD_DE_ASUNTOS_INTERNOS_DE_POLICIA_NACIONAL = 'UNIDAD_DE_ASUNTOS_INTERNOS_DE_POLICIA_NACIONAL',
  VENUS = 'VENUS',
  VODAFONE = 'VODAFONE',
  VODAFONE_ENABLER = 'VODAFONE_ENABLER',
  VODAFONE_ESPANA_FIJO = 'VODAFONE_ESPANA_FIJO',
  VOZMEDIA = 'VOZMEDIA',
  VOZTELECOM_GMM = 'VOZTELECOM_GMM',
  XENET = 'XENET',
  XISPANET = 'XISPANET',
  YOIGO = 'YOIGO',
  YOU_MOBILE = 'YOU_MOBILE',
  YUPTEL = 'YUPTEL',
  ZARZANET = 'ZARZANET'
}

export type EmailInput = {
  value: Scalars['String']['input'];
};

export type ExpeditionDetailsLinkageInput = {
  deliveryId: DeliveryIdInput;
  expeditionId: ExpeditionIdInput;
  trackingCode: TrackingCodeInput;
};

export type ExpeditionIdInput = {
  value: Scalars['String']['input'];
};

export type ExpeditionOutput = {
  __typename?: 'ExpeditionOutput';
  createdAt: Scalars['DateTime']['output'];
  hasLabel: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  labelURL?: Maybe<Scalars['String']['output']>;
  trackingCode: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ExternalAppIconOutput = {
  __typename?: 'ExternalAppIconOutput';
  iconPath: Scalars['String']['output'];
  iconURL?: Maybe<Scalars['String']['output']>;
};

export type ExternalAppOutput = {
  __typename?: 'ExternalAppOutput';
  assignmentCount: Scalars['Int']['output'];
  iconPath: Scalars['String']['output'];
  iconURL?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  isShared: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  packageName: Scalars['String']['output'];
  subtitle: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type FailedProgetProvisioningGroupOutput = {
  __typename?: 'FailedProgetProvisioningGroupOutput';
  code: Scalars['String']['output'];
  imei: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type FailedProvisioningAppReleasesOutput = {
  __typename?: 'FailedProvisioningAppReleasesOutput';
  code: Scalars['String']['output'];
  imei: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type FraudProfileFilterCriteriaInput = {
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Array<FraudProfileSource>>;
};

export type FraudProfileIdInput = {
  value: Scalars['String']['input'];
};

export type FraudProfileIdentifierInput =
  { id: FraudProfileIdInput; };

export type FraudProfileOutput = {
  __typename?: 'FraudProfileOutput';
  addresses: Array<ReportedAddressOutput>;
  createdAt: Scalars['DateTime']['output'];
  documentNumber: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  registeredByUID?: Maybe<Scalars['String']['output']>;
  source: FraudProfileSource;
  sourceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum FraudProfileSource {
  MANUAL = 'MANUAL',
  ORDER_HOLD = 'ORDER_HOLD',
  SUBSCRIPTION = 'SUBSCRIPTION'
}

export type GrandpaExternalAppOutput = {
  __typename?: 'GrandpaExternalAppOutput';
  iconPath: Scalars['String']['output'];
  iconURL?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  isShared: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  packageName: Scalars['String']['output'];
  subtitle: Scalars['String']['output'];
};

export type GrandpaUuidInput = {
  value: Scalars['String']['input'];
};

export type HolderDocumentInput = {
  number: Scalars['String']['input'];
  type: DocumentType;
};

export type IbanInput = {
  value: Scalars['String']['input'];
};

export type IndividualDetailsInput = {
  document: IndividualDocumentInput;
  email: EmailInput;
  firstName: NameInput;
  lastName: NameInput;
  phoneNumber: PhoneNumberInput;
};

export type IndividualDocumentInput = {
  number: Scalars['String']['input'];
  type: DocumentType;
};

export type InvalidFieldIssueOutput = {
  __typename?: 'InvalidFieldIssueOutput';
  errorCode: Scalars['String']['output'];
  field: OrderHoldField;
  kind: OrderHoldIssueKind;
  message: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type IssueMosCommandInput = {
  command: MosCommandInput;
  grandpaUUID: GrandpaUuidInput;
};

export type KioskModeOutput = {
  __typename?: 'KioskModeOutput';
  isKioskModeEnabled: Scalars['Boolean']['output'];
  packageName: Scalars['String']['output'];
};

export type LinkMosInput = {
  imei: DeviceImeiInput;
  uuid: DeviceUuidInput;
};

export enum MdmProvider {
  AMAPI = 'AMAPI',
  PROGET = 'PROGET'
}

export type MosCommandInput =
  { autoCall: AutoCallMosCommandInput; openApp?: never; parameterless?: never; }
  |  { autoCall?: never; openApp: OpenAppMosCommandInput; parameterless?: never; }
  |  { autoCall?: never; openApp?: never; parameterless: ParameterlessMosCommandInput; };

export type MosCommandOutput = {
  __typename?: 'MOSCommandOutput';
  completedAt: Scalars['DateTime']['output'];
  failureReason?: Maybe<Scalars['String']['output']>;
  isSuccessful: Scalars['Boolean']['output'];
  issuedAt: Scalars['DateTime']['output'];
  report: Scalars['JSON']['output'];
  type: MosCommandType;
  uuid: Scalars['String']['output'];
};

export enum MosCommandType {
  AUTO_CALL = 'AUTO_CALL',
  FETCH_INSTALLATION_ID = 'FETCH_INSTALLATION_ID',
  FETCH_STATE = 'FETCH_STATE',
  FETCH_TELEPHONY_IDS = 'FETCH_TELEPHONY_IDS',
  NTP_DIAGNOSTIC = 'NTP_DIAGNOSTIC',
  OPEN_APP = 'OPEN_APP',
  OPEN_SETTINGS = 'OPEN_SETTINGS',
  RESTART = 'RESTART',
  SETUP_DIAGNOSTIC = 'SETUP_DIAGNOSTIC'
}

export type MosInstallationStatusOutput = {
  __typename?: 'MOSInstallationStatusOutput';
  /** @deprecated AMAPI-specific applied policy version; use isApplied to know whether the policy is in effect */
  appliedPolicyVersion?: Maybe<Scalars['Int']['output']>;
  isApplied: Scalars['Boolean']['output'];
  /** @deprecated Use lastSyncAt */
  lastPolicySyncTime?: Maybe<Scalars['DateTime']['output']>;
  lastReportAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use lastReportAt */
  lastStatusReportTime?: Maybe<Scalars['DateTime']['output']>;
  lastSyncAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated AMAPI-specific target policy version; use isApplied to know whether the policy is in effect */
  policyVersion?: Maybe<Scalars['Int']['output']>;
  requestedInstallType: AppInstallType;
};

export type MosOutput = {
  __typename?: 'MOSOutput';
  grandpaPictureURL?: Maybe<Scalars['String']['output']>;
  grandpaUUID?: Maybe<Scalars['String']['output']>;
  lastBeat?: Maybe<Scalars['DateTime']['output']>;
  settings?: Maybe<Scalars['JSON']['output']>;
  status: MosStatus;
  uuid: Scalars['String']['output'];
  version?: Maybe<MosVersionOutput>;
};

export type MosSetupInput = {
  deviceUUID: DeviceUuidInput;
  grandpaName: Scalars['String']['input'];
  managerPhoneNumber: PhoneNumberInput;
};

export enum MosStatus {
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED',
  LOCKED_FOR_CHANGE = 'LOCKED_FOR_CHANGE',
  LOCKED_FOR_RETURN = 'LOCKED_FOR_RETURN',
  NOT_CONFIGURED = 'NOT_CONFIGURED'
}

export type MosVersionOutput = {
  __typename?: 'MOSVersionOutput';
  buildNumber: Scalars['Int']['output'];
  changelogURL?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MarkOrderAsFraudInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  orderId: OrderIdInput;
};

export type MaximilianerOutput = {
  __typename?: 'MaximilianerOutput';
  name?: Maybe<Scalars['String']['output']>;
  pictureURL?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export type ModifyDeliveryInput = {
  deliveryId: DeliveryIdInput;
  modificationParams: DeliveryModificationParamsInput;
};

export type ModifyFraudProfileInput = {
  addresses: Array<PostalAddressInput>;
  documentNumber: Scalars['String']['input'];
  email: Scalars['String']['input'];
  id: FraudProfileIdInput;
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type ModifyOrderInput = {
  modificationParams: OrderModificationParamsInput;
  orderId: OrderIdInput;
};

export type ModifyPersonInput = {
  details: PersonDetailsInput;
  personId: PersonIdInput;
  updatePaymentDetails?: Scalars['Boolean']['input'];
};

export type ModifyPortabilityInput = {
  modificationParams: PortabilityModificationParamsInput;
  portabilityId: PortabilityIdInput;
};

export type ModifySimExpirationDateInput = {
  iccid: SimIccidInput;
  newExpiresAt: Scalars['DateTime']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  abortCancellation: SubscriptionOutput;
  activateSim: SimOutput;
  addChangeComment: CommentOutput;
  addDeviceToProgetCanary: ProgetProvisioningGroupOutput;
  addDirectDebit: PaymentOutput;
  addOrderComment: CommentOutput;
  addShipmentComment: CommentOutput;
  addSubscriptionComment: CommentOutput;
  assignDeviceAndSimToSubscription: OrderOutput;
  assignDeviceChange: DeviceChangeOutput;
  assignExternalApp: AssignExternalAppOutput;
  assignProgetProvisioningGroup: ProgetProvisioningGroupOutput;
  assignProgetProvisioningGroups: ProgetProvisioningGroupBatchOutput;
  assignSimChange: SimChangeOutput;
  assignSimShipment: ShipmentOutput;
  cancelChange: ChangeUnionOutput;
  cancelConditionsSwitch: SubscriptionOutput;
  cancelOrder: OrderOutput;
  cancelPortability: PortabilityOutput;
  cancelShipment: ShipmentOutput;
  cancelSims: Array<SimOutput>;
  cancelWithoutRequest: SubscriptionOutput;
  completeConditionsSwitch: SubscriptionOutput;
  confirmCancellation: SubscriptionOutput;
  createB2BBox: BoxOutput;
  createExternalApp: Array<ExternalAppOutput>;
  createFromTestSimShipment: SimChangeOutput;
  createPortability: PortabilityOutput;
  deleteComment: CommentOutput;
  deleteFraudProfile: FraudProfileOutput;
  deregisterExternalApp: Array<ExternalAppOutput>;
  disableKioskMode: KioskModeOutput;
  disableVoicemail: SimOutput;
  discardOrderHold: OrderHoldOutput;
  dispatchChanges: Array<ChangeUnionOutput>;
  dispatchOrders: Array<OrderOutput>;
  dispatchShipments: Array<ShipmentOutput>;
  enableKioskMode: KioskModeOutput;
  enableVoicemail: SimOutput;
  generateShippingLabels: Array<DeliveryOutput>;
  grantUserAccess: MosOutput;
  hardResetDevice: DeviceOutput;
  initPreparationProcess: Array<OrderOutput>;
  issueInvitation: MosOutput;
  issueMOSCommand: MosCommandOutput;
  linkExpeditionDetails: DeliveryOutput;
  linkMOS: DeviceOutput;
  markOrderAsFraud: OrderOutput;
  modifyDelivery: DeliveryOutput;
  modifyFraudProfile: FraudProfileOutput;
  modifyOrder: OrderOutput;
  modifyPerson: PersonOutput;
  modifyPortability: PortabilityOutput;
  modifySimExpirationDate: SimOutput;
  placeOrder: OrderPlacementOutput;
  pushProgetMOSManagedConfiguration: PushProgetMosManagedConfigurationOutput;
  rebootDevice: RebootDeviceOutput;
  receiveOldDevice: DeviceChangeOutput;
  reconcileMDMEnrollments: Scalars['Int']['output'];
  refreshPortability: RefreshPortabilityOutput;
  registerDevices: Array<DeviceOutput>;
  registerFraudProfile: FraudProfileOutput;
  registerSim: SimOutput;
  releaseOrderHold: OrderOutput;
  removeDeviceFromProgetCanary: ProgetProvisioningGroupOutput;
  removeInvitation: MosOutput;
  removeUserAccess: MosOutput;
  replaceDevice: DeviceChangeOutput;
  replaceSim: SimChangeOutput;
  reprintExpeditionLabel: Scalars['Boolean']['output'];
  requestAdHocShipment: ShipmentOutput;
  requestCancellation: SubscriptionOutput;
  requestDeviceChange: DeviceChangeOutput;
  requestPortability: PortabilityOutput;
  requestSimChange: SimChangeOutput;
  requestSpareShipment: ShipmentOutput;
  requestTestSimShipment: ShipmentOutput;
  retryPortability: PortabilityOutput;
  setup: MosOutput;
  softReset: MosOutput;
  startShipments: Array<ShipmentOutput>;
  switchConditions: SubscriptionOutput;
  unassignExternalApp: Array<GrandpaExternalAppOutput>;
  updateApp: UpdateAppOutput;
  updateExternalApp: Array<ExternalAppOutput>;
  uploadExternalAppIcon: ExternalAppIconOutput;
};


export type MutationAbortCancellationArgs = {
  subscriptionIdInput: SubscriptionIdInput;
};


export type MutationActivateSimArgs = {
  activateSimInput: ActivateSimInput;
};


export type MutationAddChangeCommentArgs = {
  addChangeCommentInput: AddChangeCommentInput;
};


export type MutationAddDeviceToProgetCanaryArgs = {
  deviceIMEIInput: DeviceImeiInput;
};


export type MutationAddDirectDebitArgs = {
  addDirectDebitInput: AddDirectDebitInput;
};


export type MutationAddOrderCommentArgs = {
  addOrderCommentInput: AddOrderCommentInput;
};


export type MutationAddShipmentCommentArgs = {
  addShipmentCommentInput: AddShipmentCommentInput;
};


export type MutationAddSubscriptionCommentArgs = {
  addSubscriptionCommentInput: AddSubscriptionCommentInput;
};


export type MutationAssignDeviceAndSimToSubscriptionArgs = {
  assignOrderInput: AssignOrderInput;
};


export type MutationAssignDeviceChangeArgs = {
  assignDeviceChangeInput: AssignDeviceChangeInput;
};


export type MutationAssignExternalAppArgs = {
  input: AssignExternalAppInput;
};


export type MutationAssignProgetProvisioningGroupArgs = {
  deviceIMEIInput: DeviceImeiInput;
};


export type MutationAssignProgetProvisioningGroupsArgs = {
  deviceIMEIListInput: DeviceImeiListInput;
};


export type MutationAssignSimChangeArgs = {
  assignSimChangeInput: AssignSimChangeInput;
};


export type MutationAssignSimShipmentArgs = {
  assignSimShipmentInput: AssignSimShipmentInput;
};


export type MutationCancelChangeArgs = {
  changeIdInput: ChangeIdInput;
};


export type MutationCancelConditionsSwitchArgs = {
  subscriptionIdInput: SubscriptionIdInput;
};


export type MutationCancelOrderArgs = {
  cancelOrderInput: CancelOrderInput;
};


export type MutationCancelPortabilityArgs = {
  input: PortabilityIdInput;
};


export type MutationCancelShipmentArgs = {
  shipmentIdInput: ShipmentIdInput;
};


export type MutationCancelSimsArgs = {
  simICCIDListInput: SimIccidListInput;
};


export type MutationCancelWithoutRequestArgs = {
  cancelWithoutRequestInput: CancelWithoutRequestInput;
};


export type MutationCompleteConditionsSwitchArgs = {
  subscriptionIdInput: SubscriptionIdInput;
};


export type MutationConfirmCancellationArgs = {
  confirmCancellationInput: ConfirmCancellationInput;
};


export type MutationCreateB2BBoxArgs = {
  createBoxInput: CreateBoxInput;
};


export type MutationCreateExternalAppArgs = {
  createExternalAppInput: CreateExternalAppInput;
};


export type MutationCreateFromTestSimShipmentArgs = {
  shipmentIdInput: ShipmentIdInput;
};


export type MutationCreatePortabilityArgs = {
  input: CreatePortabilityInput;
};


export type MutationDeleteCommentArgs = {
  commentIdInput: CommentIdInput;
};


export type MutationDeleteFraudProfileArgs = {
  fraudProfileIdInput: FraudProfileIdInput;
};


export type MutationDeregisterExternalAppArgs = {
  deregisterExternalAppInput: DeregisterExternalAppInput;
};


export type MutationDisableKioskModeArgs = {
  deviceIMEIInput: DeviceImeiInput;
};


export type MutationDisableVoicemailArgs = {
  simICCIDInput: SimIccidInput;
};


export type MutationDiscardOrderHoldArgs = {
  discardOrderHoldInput: DiscardOrderHoldInput;
};


export type MutationDispatchChangesArgs = {
  changeIdListInput: ChangeIdListInput;
};


export type MutationDispatchOrdersArgs = {
  orderIdListInput: OrderIdListInput;
};


export type MutationDispatchShipmentsArgs = {
  shipmentIdListInput: ShipmentIdListInput;
};


export type MutationEnableKioskModeArgs = {
  deviceIMEIInput: DeviceImeiInput;
};


export type MutationEnableVoicemailArgs = {
  simICCIDInput: SimIccidInput;
};


export type MutationGenerateShippingLabelsArgs = {
  deliveryIdListInput: DeliveryIdListInput;
};


export type MutationGrantUserAccessArgs = {
  userAccessGrantInput: UserAccessGrantInput;
};


export type MutationHardResetDeviceArgs = {
  deviceIMEIInput: DeviceImeiInput;
};


export type MutationInitPreparationProcessArgs = {
  orderIdListInput: OrderIdListInput;
};


export type MutationIssueInvitationArgs = {
  userAccessGrantInput: UserAccessGrantInput;
};


export type MutationIssueMosCommandArgs = {
  issueMOSCommandInput: IssueMosCommandInput;
};


export type MutationLinkExpeditionDetailsArgs = {
  expeditionDetailsLinkageInput: ExpeditionDetailsLinkageInput;
};


export type MutationLinkMosArgs = {
  linkMOSInput: LinkMosInput;
};


export type MutationMarkOrderAsFraudArgs = {
  markOrderAsFraudInput: MarkOrderAsFraudInput;
};


export type MutationModifyDeliveryArgs = {
  modifyDeliveryInput: ModifyDeliveryInput;
};


export type MutationModifyFraudProfileArgs = {
  modifyFraudProfileInput: ModifyFraudProfileInput;
};


export type MutationModifyOrderArgs = {
  modifyOrderInput: ModifyOrderInput;
};


export type MutationModifyPersonArgs = {
  modifyPersonInput: ModifyPersonInput;
};


export type MutationModifyPortabilityArgs = {
  input: ModifyPortabilityInput;
};


export type MutationModifySimExpirationDateArgs = {
  modifySimExpirationDateInput: ModifySimExpirationDateInput;
};


export type MutationPlaceOrderArgs = {
  placeOrderInput: PlaceOrderInput;
};


export type MutationPushProgetMosManagedConfigurationArgs = {
  deviceIMEIInput: DeviceImeiInput;
};


export type MutationRebootDeviceArgs = {
  deviceIMEIInput: DeviceImeiInput;
};


export type MutationReceiveOldDeviceArgs = {
  deviceIMEIInput: DeviceImeiInput;
};


export type MutationRefreshPortabilityArgs = {
  input: PortabilityIdInput;
};


export type MutationRegisterDevicesArgs = {
  deviceIMEIListInput: DeviceImeiListInput;
};


export type MutationRegisterFraudProfileArgs = {
  registerFraudProfileInput: RegisterFraudProfileInput;
};


export type MutationRegisterSimArgs = {
  registerSimInput: RegisterSimInput;
};


export type MutationReleaseOrderHoldArgs = {
  releaseOrderHoldInput: ReleaseOrderHoldInput;
};


export type MutationRemoveDeviceFromProgetCanaryArgs = {
  deviceIMEIInput: DeviceImeiInput;
};


export type MutationRemoveInvitationArgs = {
  userAccessRemovalInput: UserAccessRemovalInput;
};


export type MutationRemoveUserAccessArgs = {
  userAccessRemovalInput: UserAccessRemovalInput;
};


export type MutationReplaceDeviceArgs = {
  changeIdInput: ChangeIdInput;
};


export type MutationReplaceSimArgs = {
  changeIdInput: ChangeIdInput;
};


export type MutationReprintExpeditionLabelArgs = {
  deliveryIdInput: DeliveryIdInput;
};


export type MutationRequestAdHocShipmentArgs = {
  requestAdHocShipmentInput: RequestAdHocShipmentInput;
};


export type MutationRequestCancellationArgs = {
  requestCancellationInput: RequestCancellationInput;
};


export type MutationRequestDeviceChangeArgs = {
  requestDeviceChangeInput: RequestDeviceChangeInput;
};


export type MutationRequestPortabilityArgs = {
  input: RequestPortabilityInput;
};


export type MutationRequestSimChangeArgs = {
  requestSimChangeInput: RequestSimChangeInput;
};


export type MutationRequestSpareShipmentArgs = {
  requestSpareShipmentInput: RequestSpareShipmentInput;
};


export type MutationRequestTestSimShipmentArgs = {
  requestTestSimShipmentInput: RequestTestSimShipmentInput;
};


export type MutationRetryPortabilityArgs = {
  input: RetryPortabilityInput;
};


export type MutationSetupArgs = {
  mosSetupInput: MosSetupInput;
};


export type MutationSoftResetArgs = {
  deviceUUIDInput: DeviceUuidInput;
};


export type MutationStartShipmentsArgs = {
  shipmentIdListInput: ShipmentIdListInput;
};


export type MutationSwitchConditionsArgs = {
  switchConditionsInput: SwitchConditionsInput;
};


export type MutationUnassignExternalAppArgs = {
  input: UnassignExternalAppInput;
};


export type MutationUpdateAppArgs = {
  updateAppInput: UpdateAppInput;
};


export type MutationUpdateExternalAppArgs = {
  updateExternalAppInput: UpdateExternalAppInput;
};


export type MutationUploadExternalAppIconArgs = {
  uploadExternalAppIconInput: UploadExternalAppIconInput;
};

export type NameInput = {
  value: Scalars['String']['input'];
};

export type NonStripePaymentDetailsInput = {
  type: PaymentType;
};

export type OpenAppMosCommandInput = {
  packageName: PackageNameInput;
};

export type OrderByInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type OrderFilterCriteriaInput = {
  status?: InputMaybe<Array<OrderStatus>>;
};

export type OrderHoldCorrectionsInput = {
  address?: InputMaybe<PostalAddressInput>;
  customer?: InputMaybe<PersonDetailsInput>;
};

export enum OrderHoldDiscardReason {
  FRAUD = 'FRAUD',
  OTHER = 'OTHER'
}

export enum OrderHoldField {
  ADDRESS = 'ADDRESS',
  DOCUMENT_NUMBER = 'DOCUMENT_NUMBER',
  EMAIL = 'EMAIL',
  NAME = 'NAME',
  PHONE_NUMBER = 'PHONE_NUMBER'
}

export type OrderHoldFilterCriteriaInput = {
  status?: InputMaybe<Array<OrderHoldStatus>>;
};

export type OrderHoldIdInput = {
  value: Scalars['String']['input'];
};

export type OrderHoldIdentifierInput =
  { id: OrderHoldIdInput; orderId?: never; paymentId?: never; }
  |  { id?: never; orderId: OrderIdInput; paymentId?: never; }
  |  { id?: never; orderId?: never; paymentId: PaymentIdInput; };

export enum OrderHoldIssueKind {
  CONTACT_DATA_IN_USE = 'CONTACT_DATA_IN_USE',
  INVALID_FIELD = 'INVALID_FIELD',
  SUSPICION = 'SUSPICION',
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR'
}

export type OrderHoldIssueOutput = ContactDataInUseIssueOutput | InvalidFieldIssueOutput | SuspicionIssueOutput | UnexpectedErrorIssueOutput;

export type OrderHoldOutput = {
  __typename?: 'OrderHoldOutput';
  address: ReportedAddressOutput;
  businessName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  discardReason?: Maybe<OrderHoldDiscardReason>;
  documentNumber: Scalars['String']['output'];
  documentType?: Maybe<DocumentType>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  issues: Array<OrderHoldIssueOutput>;
  lastName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  order?: Maybe<OrderOutput>;
  payment: PaymentOutput;
  phoneNumber: Scalars['String']['output'];
  resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  resolvedByUID?: Maybe<Scalars['String']['output']>;
  status: OrderHoldStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum OrderHoldStatus {
  DISCARDED = 'DISCARDED',
  PENDING = 'PENDING',
  RELEASED = 'RELEASED'
}

export type OrderIdInput = {
  value: Scalars['String']['input'];
};

export type OrderIdListInput = {
  values: Array<OrderIdInput>;
};

export type OrderIdentifierInput =
  { id: OrderIdInput; };

export type OrderModificationParamsInput = {
  acquisitionChannel?: InputMaybe<AcquisitionChannel>;
  grandpaNickname?: InputMaybe<Scalars['String']['input']>;
  wantsLandlinePortability?: InputMaybe<Scalars['Boolean']['input']>;
  wantsPortability?: InputMaybe<Scalars['Boolean']['input']>;
  wantsSIM?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderOutput = {
  __typename?: 'OrderOutput';
  acquisitionChannel?: Maybe<AcquisitionChannel>;
  comments: Array<CommentOutput>;
  coupon?: Maybe<Scalars['String']['output']>;
  delivery: DeliveryOutput;
  id: Scalars['String']['output'];
  placedAt: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  subscription: SubscriptionOutput;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  wantsLandlinePortability: Scalars['Boolean']['output'];
  wantsPortability: Scalars['Boolean']['output'];
  wantsSIM: Scalars['Boolean']['output'];
};

export enum OrderPlacementOutcomeStatus {
  HELD = 'HELD',
  PLACED = 'PLACED'
}

export type OrderPlacementOutput = {
  __typename?: 'OrderPlacementOutput';
  order?: Maybe<OrderOutput>;
  orderHold?: Maybe<OrderHoldOutput>;
  status: OrderPlacementOutcomeStatus;
};

export enum OrderStatus {
  CANCELLED = 'CANCELLED',
  CONFIRMED = 'CONFIRMED',
  IN_PREPARATION = 'IN_PREPARATION',
  PACKAGED = 'PACKAGED',
  SHIPPED = 'SHIPPED'
}

export type OrdersStatsOutput = {
  __typename?: 'OrdersStatsOutput';
  acquisitionChannels: Scalars['JSON']['output'];
  bestDay: Scalars['JSON']['output'];
  byProvince: Scalars['JSON']['output'];
  cancelledOrders: Scalars['JSON']['output'];
  currentMonthProjection: Scalars['Float']['output'];
  daily: Scalars['JSON']['output'];
  dailyAverageLast14Days: Scalars['Float']['output'];
  detailedAcquisitionChannelsEvolution: Scalars['JSON']['output'];
  groupedAcquisitionChannelsEvolution: Scalars['JSON']['output'];
  lastWeek: Scalars['JSON']['output'];
  total: Scalars['JSON']['output'];
  weeklyDistribution: Scalars['JSON']['output'];
};

export type PackageNameInput = {
  value: Scalars['String']['input'];
};

export type PackageNameListInput = {
  values: Array<PackageNameInput>;
};

export type PaginationInput = {
  skip?: InputMaybe<Scalars['Float']['input']>;
  take?: InputMaybe<Scalars['Float']['input']>;
};

export type ParameterlessMosCommandInput = {
  type: MosCommandType;
};

export type PaymentDetailsInput =
  { nonStripe: NonStripePaymentDetailsInput; stripe?: never; }
  |  { nonStripe?: never; stripe: StripePaymentDetailsInput; };

export type PaymentIdInput = {
  value: Scalars['String']['input'];
};

export type PaymentMethodOutput = {
  __typename?: 'PaymentMethodOutput';
  cardBrand?: Maybe<CardBrand>;
  last4: Scalars['String']['output'];
  type: PaymentMethodType;
};

export enum PaymentMethodType {
  CARD = 'CARD',
  SEPA_DEBIT = 'SEPA_DEBIT'
}

export type PaymentOutput = {
  __typename?: 'PaymentOutput';
  id: Scalars['String']['output'];
  orderHold?: Maybe<OrderHoldOutput>;
  paymentMethod?: Maybe<PaymentMethodOutput>;
  status?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<SubscriptionOutput>;
  type: Scalars['String']['output'];
};

export enum PaymentType {
  B2B = 'B2B',
  DISTRIBUTOR = 'DISTRIBUTOR',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  STRIPE = 'STRIPE',
  TRANSFER = 'TRANSFER'
}

export type PersonDetailsInput =
  { company: CompanyDetailsInput; individual?: never; }
  |  { company?: never; individual: IndividualDetailsInput; };

export type PersonFilterCriteriaInput = {
  orderBy?: InputMaybe<PersonOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  subscriptionStatus?: InputMaybe<Array<SubscriptionStatus>>;
};

export type PersonIdInput = {
  value: Scalars['String']['input'];
};

export type PersonIdentifierInput =
  { documentNumber: DocumentNumberInput; email?: never; id?: never; phoneNumber?: never; }
  |  { documentNumber?: never; email: EmailInput; id?: never; phoneNumber?: never; }
  |  { documentNumber?: never; email?: never; id: PersonIdInput; phoneNumber?: never; }
  |  { documentNumber?: never; email?: never; id?: never; phoneNumber: PhoneNumberInput; };

export enum PersonOrderAllowedFields {
  CREATED_AT = 'CREATED_AT',
  DOCUMENT_NUMBER = 'DOCUMENT_NUMBER',
  EMAIL = 'EMAIL',
  ID = 'ID',
  NAME = 'NAME',
  PHONE_NUMBER = 'PHONE_NUMBER',
  SUBSCRIPTIONS_COUNT = 'SUBSCRIPTIONS_COUNT',
  UPDATED_AT = 'UPDATED_AT'
}

export type PersonOrderByInput = {
  field: PersonOrderAllowedFields;
  sortDirection?: InputMaybe<SortDirection>;
};

export type PersonOutput = {
  __typename?: 'PersonOutput';
  avatarURL?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  documentNumber: Scalars['String']['output'];
  documentType: DocumentType;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  subscriptions: Array<SubscriptionOutput>;
};

export type PersonPaginatedOutput = {
  __typename?: 'PersonPaginatedOutput';
  total: Scalars['Float']['output'];
  values: Array<PersonOutput>;
};

export type PhoneNumberInput = {
  value: Scalars['String']['input'];
};

export type PlaceOrderInput = {
  acquisitionChannel: AcquisitionChannel;
  address: PostalAddressInput;
  boxId?: InputMaybe<BoxIdInput>;
  conditionsId: ConditionsIdInput;
  customer: PersonDetailsInput;
  grandpaNickname: Scalars['String']['input'];
  paymentDetails: PaymentDetailsInput;
  sendCustomerNotification: Scalars['Boolean']['input'];
  sendTeamNotification: Scalars['Boolean']['input'];
  wantsLandlinePortability: Scalars['Boolean']['input'];
  wantsPortability: Scalars['Boolean']['input'];
  wantsSIM: Scalars['Boolean']['input'];
};

export type PortabilityFilterCriteriaInput = {
  orderBy?: InputMaybe<OrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  portabilityStatus?: InputMaybe<Array<PortabilityStatus>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
};

export type PortabilityIdInput = {
  value: Scalars['String']['input'];
};

export type PortabilityIdentifierInput =
  { carrierPortabilityId: CarrierPortabilityIdInput; id?: never; }
  |  { carrierPortabilityId?: never; id: PortabilityIdInput; };

export type PortabilityModificationParamsInput = {
  donorCarrier?: InputMaybe<DonorCarrier>;
  holderDocument?: InputMaybe<HolderDocumentInput>;
  holderFullName?: InputMaybe<NameInput>;
  planType?: InputMaybe<PortabilityPlanType>;
  portingPhoneNumber?: InputMaybe<PhoneNumberInput>;
  prepaidSimICCID?: InputMaybe<SimIccidInput>;
  schedule?: InputMaybe<PortabilitySchedule>;
};

export type PortabilityOutput = {
  __typename?: 'PortabilityOutput';
  carrierPortabilityId?: Maybe<Scalars['String']['output']>;
  carrierPortabilityStatus?: Maybe<Scalars['String']['output']>;
  changeWindowAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  donorCarrier: Scalars['String']['output'];
  holderDocumentNumber: Scalars['String']['output'];
  holderDocumentType: Scalars['String']['output'];
  holderName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  planType: PortabilityPlanType;
  portingPhoneNumber: Scalars['String']['output'];
  prepaidSimICCID?: Maybe<Scalars['String']['output']>;
  recipientCarrier?: Maybe<Scalars['String']['output']>;
  recipientSimICCID?: Maybe<Scalars['String']['output']>;
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  schedule: PortabilitySchedule;
  status: PortabilityStatus;
  subscription: SubscriptionOutput;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PortabilityPaginatedOutput = {
  __typename?: 'PortabilityPaginatedOutput';
  total: Scalars['Float']['output'];
  values: Array<PortabilityOutput>;
};

export enum PortabilityPlanType {
  CONTRACT = 'CONTRACT',
  PREPAID = 'PREPAID'
}

export enum PortabilitySchedule {
  MANUAL = 'MANUAL',
  ON_SHIPMENT = 'ON_SHIPMENT'
}

export enum PortabilityStatus {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  REQUESTED = 'REQUESTED'
}

export type PostalAddressInput = {
  city: Scalars['String']['input'];
  country: CountryCode;
  firstLine: Scalars['String']['input'];
  secondLine: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type PostalAddressOutput = {
  __typename?: 'PostalAddressOutput';
  city: Scalars['String']['output'];
  country: CountryCode;
  firstLine: Scalars['String']['output'];
  province?: Maybe<Scalars['String']['output']>;
  secondLine?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
};

export type ProgetAppReleaseOutput = {
  __typename?: 'ProgetAppReleaseOutput';
  name: Scalars['String']['output'];
  packageName: Scalars['String']['output'];
  progetApplicationUUID: Scalars['String']['output'];
  sizeBytes?: Maybe<Scalars['Int']['output']>;
  version: Scalars['String']['output'];
  versionCode: Scalars['Int']['output'];
};

export type ProgetDeviceManagementOutput = DeviceManagementOutput & {
  __typename?: 'ProgetDeviceManagementOutput';
  alias?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Scalars['String']['output']>>;
  lastContactTime?: Maybe<Scalars['DateTime']['output']>;
  mdmClientVersion?: Maybe<Scalars['String']['output']>;
  progetUUID: Scalars['String']['output'];
  provider: MdmProvider;
};

export type ProgetProvisioningGroupBatchOutput = {
  __typename?: 'ProgetProvisioningGroupBatchOutput';
  assigned: Array<ProgetProvisioningGroupOutput>;
  failed: Array<FailedProgetProvisioningGroupOutput>;
};

export type ProgetProvisioningGroupOutput = {
  __typename?: 'ProgetProvisioningGroupOutput';
  alias: Scalars['String']['output'];
  imei: Scalars['String']['output'];
};

export type ProvisioningAppReleasesBatchOutput = {
  __typename?: 'ProvisioningAppReleasesBatchOutput';
  failed: Array<FailedProvisioningAppReleasesOutput>;
  resolved: Array<ProvisioningAppReleasesOutput>;
};

export type ProvisioningAppReleasesOutput = {
  __typename?: 'ProvisioningAppReleasesOutput';
  imei: Scalars['String']['output'];
  releases: Array<ProgetAppReleaseOutput>;
};

export type PushProgetMosManagedConfigurationOutput = {
  __typename?: 'PushProgetMOSManagedConfigurationOutput';
  imei: Scalars['String']['output'];
  packageName: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  cancellation: CancellationOutput;
  cancellations: CancellationPaginatedOutput;
  change: ChangeUnionOutput;
  changes: ChangeUnionPaginatedOutput;
  conditions: Array<ConditionsOutput>;
  device?: Maybe<DeviceOutput>;
  deviceChange?: Maybe<DeviceChangeOutput>;
  deviceChanges: DeviceChangePaginatedOutput;
  devices: DevicePaginatedOutput;
  externalAppIcons: Array<ExternalAppIconOutput>;
  externalApps: Array<ExternalAppOutput>;
  fraudProfile: FraudProfileOutput;
  fraudProfiles: Array<FraudProfileOutput>;
  generateEnrollmentQR: Scalars['String']['output'];
  order?: Maybe<OrderOutput>;
  orderHold: OrderHoldOutput;
  orderHolds: Array<OrderHoldOutput>;
  orders: Array<OrderOutput>;
  person?: Maybe<PersonOutput>;
  persons: PersonPaginatedOutput;
  portabilities: PortabilityPaginatedOutput;
  portability: PortabilityOutput;
  provisioningAppReleases: ProvisioningAppReleasesBatchOutput;
  relatedSubscriptions: RelatedSubscriptionsPaginatedOutput;
  resources: Array<ResourceOutput>;
  shipment?: Maybe<ShipmentOutput>;
  shipments: ShipmentPaginatedOutput;
  sim?: Maybe<SimOutput>;
  simChange: SimChangeOutput;
  simChanges: SimChangePaginatedOutput;
  sims: SimPaginatedOutput;
  stats: StatsOutput;
  subscription?: Maybe<SubscriptionOutput>;
  subscriptions: SubscriptionPaginatedOutput;
};


export type QueryCancellationArgs = {
  by: CancellationIdentifierInput;
};


export type QueryCancellationsArgs = {
  criteria?: InputMaybe<CancellationFilterCriteriaInput>;
};


export type QueryChangeArgs = {
  by: ChangeIdentifierInput;
};


export type QueryChangesArgs = {
  criteria?: InputMaybe<ChangeFilterCriteriaInput>;
};


export type QueryConditionsArgs = {
  criteria?: InputMaybe<ConditionsFilterCriteriaInput>;
};


export type QueryDeviceArgs = {
  by: DeviceIdentifierInput;
};


export type QueryDeviceChangeArgs = {
  by: ChangeIdentifierInput;
};


export type QueryDeviceChangesArgs = {
  criteria?: InputMaybe<DeviceChangeFilterCriteriaInput>;
};


export type QueryDevicesArgs = {
  criteria?: InputMaybe<DeviceFilterCriteriaInput>;
};


export type QueryFraudProfileArgs = {
  by: FraudProfileIdentifierInput;
};


export type QueryFraudProfilesArgs = {
  filter?: InputMaybe<FraudProfileFilterCriteriaInput>;
};


export type QueryOrderArgs = {
  by: OrderIdentifierInput;
};


export type QueryOrderHoldArgs = {
  by: OrderHoldIdentifierInput;
};


export type QueryOrderHoldsArgs = {
  filter?: InputMaybe<OrderHoldFilterCriteriaInput>;
};


export type QueryOrdersArgs = {
  filter?: InputMaybe<OrderFilterCriteriaInput>;
};


export type QueryPersonArgs = {
  by: PersonIdentifierInput;
};


export type QueryPersonsArgs = {
  criteria?: InputMaybe<PersonFilterCriteriaInput>;
};


export type QueryPortabilitiesArgs = {
  criteria?: InputMaybe<PortabilityFilterCriteriaInput>;
};


export type QueryPortabilityArgs = {
  by: PortabilityIdentifierInput;
};


export type QueryProvisioningAppReleasesArgs = {
  deviceIMEIListInput: DeviceImeiListInput;
  packageNameListInput: PackageNameListInput;
};


export type QueryRelatedSubscriptionsArgs = {
  phoneNumber: PhoneNumberInput;
};


export type QueryResourcesArgs = {
  input: SearchResourceInput;
};


export type QueryShipmentArgs = {
  by: ShipmentIdentifierInput;
};


export type QueryShipmentsArgs = {
  criteria?: InputMaybe<ShipmentFilterCriteriaInput>;
};


export type QuerySimArgs = {
  by: SimIdentifierInput;
};


export type QuerySimChangeArgs = {
  by: ChangeIdentifierInput;
};


export type QuerySimChangesArgs = {
  criteria?: InputMaybe<SimChangeFilterCriteriaInput>;
};


export type QuerySimsArgs = {
  criteria?: InputMaybe<SimFilterCriteriaInput>;
};


export type QuerySubscriptionArgs = {
  by: SubscriptionIdentifierInput;
};


export type QuerySubscriptionsArgs = {
  criteria?: InputMaybe<SubscriptionFilterCriteriaInput>;
};

export type RebootDeviceOutput = {
  __typename?: 'RebootDeviceOutput';
  imei: Scalars['String']['output'];
  isRebooted: Scalars['Boolean']['output'];
};

export type RefreshPortabilityOutput = {
  __typename?: 'RefreshPortabilityOutput';
  portability: PortabilityOutput;
  wasUpdated: Scalars['Boolean']['output'];
};

export enum RefundStrategy {
  AUTO = 'AUTO',
  SKIP = 'SKIP'
}

export type RegisterFraudProfileInput = {
  addresses: Array<PostalAddressInput>;
  documentNumber: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type RegisterSimInput = {
  iccid: SimIccidInput;
  phoneNumber?: InputMaybe<PhoneNumberInput>;
  type?: InputMaybe<SimType>;
};

export type RelatedSubscriptionOutput = {
  __typename?: 'RelatedSubscriptionOutput';
  roles: Array<RoleType>;
  subscription: SubscriptionOutput;
};

export type RelatedSubscriptionsPaginatedOutput = {
  __typename?: 'RelatedSubscriptionsPaginatedOutput';
  total: Scalars['Float']['output'];
  values: Array<RelatedSubscriptionOutput>;
};

export type ReleaseOrderHoldInput = {
  corrections: OrderHoldCorrectionsInput;
  id: OrderHoldIdInput;
};

export enum RemovedSimAction {
  CANCEL = 'CANCEL',
  FREEZE = 'FREEZE'
}

export type ReportedAddressOutput = {
  __typename?: 'ReportedAddressOutput';
  city: Scalars['String']['output'];
  country: CountryCode;
  firstLine: Scalars['String']['output'];
  secondLine?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
};

export type RequestAdHocShipmentInput = {
  address: PostalAddressInput;
  comments?: InputMaybe<Scalars['String']['input']>;
  email: EmailInput;
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<PhoneNumberInput>;
};

export type RequestCancellationInput = {
  address?: InputMaybe<PostalAddressInput>;
  keepNumber?: InputMaybe<Scalars['Boolean']['input']>;
  reason: SubscriptionCancellationReason;
  reasonDetails?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: SubscriptionIdInput;
};

export type RequestDeviceChangeInput = {
  address?: InputMaybe<PostalAddressInput>;
  comments?: InputMaybe<Scalars['String']['input']>;
  previousChecks: Scalars['JSON']['input'];
  reason: RequestableDeviceChangeReason;
  requiredAction: DeviceChangeRequiredAction;
  spares: Array<Spares>;
  subscriptionId: SubscriptionIdInput;
};

export type RequestPortabilityInput = {
  id: PortabilityIdInput;
  simICCID: SimIccidInput;
};

export type RequestSimChangeInput = {
  address?: InputMaybe<PostalAddressInput>;
  comments?: InputMaybe<Scalars['String']['input']>;
  previousChecks: Scalars['JSON']['input'];
  reason: RequestableSimChangeReason;
  spares: Array<Spares>;
  subscriptionId: SubscriptionIdInput;
};

export type RequestSpareShipmentInput = {
  address?: InputMaybe<PostalAddressInput>;
  comments?: InputMaybe<Scalars['String']['input']>;
  spares: Array<Spares>;
  subscriptionId: SubscriptionIdInput;
};

export type RequestTestSimShipmentInput = {
  address?: InputMaybe<PostalAddressInput>;
  comments?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: SubscriptionIdInput;
};

export enum RequestableDeviceChangeReason {
  BROKEN_MIC = 'BROKEN_MIC',
  BROKEN_SCREEN = 'BROKEN_SCREEN',
  CONNECTIVITY_PROBLEM = 'CONNECTIVITY_PROBLEM',
  DAMAGED_CHARGING_PORT = 'DAMAGED_CHARGING_PORT',
  DEVICE_USAGE_SIGNS = 'DEVICE_USAGE_SIGNS',
  HARD_RESET = 'HARD_RESET',
  LOST = 'LOST',
  SHORT_BATTERY_LIFE = 'SHORT_BATTERY_LIFE',
  SLOW_CHARGING = 'SLOW_CHARGING',
  SWOLLEN_BATTERY = 'SWOLLEN_BATTERY',
  VOLUME_ISSUES = 'VOLUME_ISSUES',
  WHITE_QR = 'WHITE_QR'
}

export enum RequestableSimChangeReason {
  BROKEN = 'BROKEN',
  COVERAGE_ISSUES = 'COVERAGE_ISSUES',
  LOST_OR_STOLEN = 'LOST_OR_STOLEN',
  WANTS_NEW_NUMBER = 'WANTS_NEW_NUMBER',
  WANTS_PORTABILITY = 'WANTS_PORTABILITY'
}

export type ResourceOutput = {
  __typename?: 'ResourceOutput';
  id: Scalars['String']['output'];
  primaryText: Scalars['String']['output'];
  quaternaryText?: Maybe<Scalars['String']['output']>;
  secondaryText?: Maybe<Scalars['String']['output']>;
  tertiaryText?: Maybe<Scalars['String']['output']>;
  type: ResourceType;
};

export enum ResourceType {
  CHANGE = 'CHANGE',
  DEVICE = 'DEVICE',
  ORDER = 'ORDER',
  PERSON = 'PERSON',
  PORTABILITY = 'PORTABILITY',
  SIM = 'SIM',
  SUBSCRIPTION = 'SUBSCRIPTION'
}

export type RetryPortabilityInput = {
  modificationParams: RetryPortabilityModificationParamsInput;
  portabilityId: PortabilityIdInput;
};

export type RetryPortabilityModificationParamsInput = {
  holderDocument?: InputMaybe<HolderDocumentInput>;
  holderFullName?: InputMaybe<NameInput>;
  planType?: InputMaybe<PortabilityPlanType>;
  prepaidSimICCID?: InputMaybe<SimIccidInput>;
};

export enum RoleType {
  CONTACT = 'CONTACT',
  CONTRACTOR = 'CONTRACTOR',
  EMERGENCY_CONTACT = 'EMERGENCY_CONTACT',
  INVITEE = 'INVITEE',
  MANAGER = 'MANAGER',
  MEMBER = 'MEMBER'
}

export type SearchResourceInput = {
  searchString: Scalars['String']['input'];
  types?: InputMaybe<Array<ResourceType>>;
};

export type ShipmentFilterCriteriaInput = {
  orderBy?: InputMaybe<OrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  simICCID?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<ShippableStatus>>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Array<ShipmentType>>;
};

export type ShipmentIdInput = {
  value: Scalars['String']['input'];
};

export type ShipmentIdListInput = {
  values: Array<ShipmentIdInput>;
};

export type ShipmentIdentifierInput =
  { id: ShipmentIdInput; };

export type ShipmentOutput = {
  __typename?: 'ShipmentOutput';
  comments: Array<CommentOutput>;
  createdAt: Scalars['DateTime']['output'];
  delivery: DeliveryOutput;
  id: Scalars['String']['output'];
  requestedBy?: Maybe<MaximilianerOutput>;
  sim?: Maybe<SimOutput>;
  spares?: Maybe<Array<Spares>>;
  status: ShippableStatus;
  subscription?: Maybe<SubscriptionOutput>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ShipmentPaginatedOutput = {
  __typename?: 'ShipmentPaginatedOutput';
  total: Scalars['Float']['output'];
  values: Array<ShipmentOutput>;
};

export enum ShipmentType {
  AD_HOC = 'AD_HOC',
  SIM_UPGRADE = 'SIM_UPGRADE',
  SPARE = 'SPARE',
  TEST_SIM = 'TEST_SIM'
}

export enum ShippableStatus {
  CANCELLED = 'CANCELLED',
  IN_PROGRESS = 'IN_PROGRESS',
  REQUESTED = 'REQUESTED',
  SHIPPED = 'SHIPPED'
}

export type SimChangeFilterCriteriaInput = {
  newSimICCID?: InputMaybe<Scalars['String']['input']>;
  oldSimICCID?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  reason?: InputMaybe<Array<SimChangeReason>>;
  requiredAction?: InputMaybe<Array<SimChangeRequiredAction>>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<ChangeStatus>>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ChangeType>;
};

export type SimChangeOutput = ChangeOutput & {
  __typename?: 'SimChangeOutput';
  comments: Array<CommentOutput>;
  createdAt: Scalars['DateTime']['output'];
  delivery: DeliveryOutput;
  id: Scalars['String']['output'];
  newSim?: Maybe<SimOutput>;
  oldSim: SimOutput;
  previousChecks?: Maybe<Scalars['JSON']['output']>;
  reason: ChangeReason;
  requestedBy?: Maybe<MaximilianerOutput>;
  requiredAction: SimChangeRequiredAction;
  spares: Array<Spares>;
  status: ChangeStatus;
  subscription: SubscriptionOutput;
  type: ChangeType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SimChangePaginatedOutput = {
  __typename?: 'SimChangePaginatedOutput';
  total: Scalars['Float']['output'];
  values: Array<SimChangeOutput>;
};

export enum SimChangeReason {
  BROKEN = 'BROKEN',
  COVERAGE_ISSUES = 'COVERAGE_ISSUES',
  LOST_OR_STOLEN = 'LOST_OR_STOLEN',
  OTHER = 'OTHER',
  WANTS_NEW_NUMBER = 'WANTS_NEW_NUMBER',
  WANTS_PORTABILITY = 'WANTS_PORTABILITY'
}

export enum SimChangeRequiredAction {
  INTERNAL_PORTABILITY = 'INTERNAL_PORTABILITY',
  REGULAR_REPLACEMENT = 'REGULAR_REPLACEMENT',
  SIM_DUPLICATE = 'SIM_DUPLICATE'
}

export type SimFilterCriteriaInput = {
  orderBy?: InputMaybe<OrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<SimStatus>>;
  type?: InputMaybe<Array<SimType>>;
};

export type SimIccidInput = {
  value: Scalars['String']['input'];
};

export type SimIccidListInput = {
  values: Array<SimIccidInput>;
};

export type SimIdentifierInput =
  { iccid: SimIccidInput; phoneNumber?: never; }
  |  { iccid?: never; phoneNumber: PhoneNumberInput; };

export type SimOutput = {
  __typename?: 'SimOutput';
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  dataConsumption?: Maybe<DataConsumptionOutput>;
  dataPlan: DataPlanOutput;
  expirationNotifiedAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  iccid: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  previousPhoneNumber?: Maybe<Scalars['String']['output']>;
  previousSubscriptions?: Maybe<Array<SubscriptionOutput>>;
  registeredAt: Scalars['DateTime']['output'];
  relatedSimChanges: Array<SimChangeOutput>;
  status: SimStatus;
  subscription?: Maybe<SubscriptionOutput>;
  type: SimType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  voicemailStatus?: Maybe<VoicemailStatus>;
};

export type SimPaginatedOutput = {
  __typename?: 'SimPaginatedOutput';
  total: Scalars['Float']['output'];
  values: Array<SimOutput>;
};

export enum SimStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  FROZEN = 'FROZEN',
  GONE = 'GONE',
  PENDING_ACTIVATION = 'PENDING_ACTIVATION',
  PENDING_CANCELLATION = 'PENDING_CANCELLATION',
  REPLACED = 'REPLACED'
}

export enum SimType {
  NEW_NUMBER = 'NEW_NUMBER',
  PORTABILITY = 'PORTABILITY'
}

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum Spares {
  CHARGING_BASE = 'CHARGING_BASE',
  CHARGING_BASE_OLD_MODEL = 'CHARGING_BASE_OLD_MODEL',
  CHARGING_CABLE_USB_C = 'CHARGING_CABLE_USB_C',
  CHARGING_CABLE_USB_MICRO = 'CHARGING_CABLE_USB_MICRO',
  CHARGING_MAGNET_USB_C = 'CHARGING_MAGNET_USB_C',
  CHARGING_MAGNET_USB_MICRO = 'CHARGING_MAGNET_USB_MICRO',
  MAGNETIC_CHARGING_CABLE = 'MAGNETIC_CHARGING_CABLE',
  PHONE_CASE_G05 = 'PHONE_CASE_G05',
  PHONE_CASE_REDMI_9A = 'PHONE_CASE_REDMI_9A',
  POWER_SUPPLY_USB_A = 'POWER_SUPPLY_USB_A',
  SCREEN_PROTECTOR_G05 = 'SCREEN_PROTECTOR_G05',
  SCREEN_PROTECTOR_REDMI_9A = 'SCREEN_PROTECTOR_REDMI_9A'
}

export type StatsOutput = {
  __typename?: 'StatsOutput';
  cancellations: CancellationsStatsOutput;
  devices: DevicesStatsOutput;
  orders: OrdersStatsOutput;
  subscriptions: SubscriptionsStatsOutput;
};

export type StripePaymentDetailsInput = {
  stripeSubscriptionId: StripeSubscriptionIdInput;
};

export type StripeSubscriptionIdInput = {
  value: Scalars['String']['input'];
};

export enum SubscriptionCancellationReason {
  EXITUS = 'EXITUS',
  FRAUD = 'FRAUD',
  HEALTH_DETERIORATION = 'HEALTH_DETERIORATION',
  INSUFFICIENT_VOLUME = 'INSUFFICIENT_VOLUME',
  LACK_OF_MOBILE_FUNTIONALITIES = 'LACK_OF_MOBILE_FUNTIONALITIES',
  MOBILE_MALFUNCTION = 'MOBILE_MALFUNCTION',
  MOBILE_WEIGHT_DIFFICULTY = 'MOBILE_WEIGHT_DIFFICULTY',
  OTHER = 'OTHER',
  PILOT_ENDED = 'PILOT_ENDED',
  PILOT_TO_CLIENT = 'PILOT_TO_CLIENT',
  TOUCHSCREEN_DIFFICULTY = 'TOUCHSCREEN_DIFFICULTY',
  USER_REFUSAL = 'USER_REFUSAL'
}

export enum SubscriptionDisplayStatus {
  ACTIVE = 'ACTIVE',
  CANCELLATION_REQUESTED = 'CANCELLATION_REQUESTED',
  CANCELLED = 'CANCELLED',
  PENDING = 'PENDING'
}

export type SubscriptionFilterCriteriaInput = {
  orderBy?: InputMaybe<SubscriptionOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<SubscriptionStatus>>;
};

export type SubscriptionIdInput = {
  value: Scalars['String']['input'];
};

export type SubscriptionIdentifierInput =
  { deviceIMEI: DeviceImeiInput; id?: never; orderId?: never; simICCID?: never; }
  |  { deviceIMEI?: never; id: SubscriptionIdInput; orderId?: never; simICCID?: never; }
  |  { deviceIMEI?: never; id?: never; orderId: OrderIdInput; simICCID?: never; }
  |  { deviceIMEI?: never; id?: never; orderId?: never; simICCID: SimIccidInput; };

export enum SubscriptionOrderAllowedFields {
  CREATED_AT = 'CREATED_AT',
  ID = 'ID'
}

export type SubscriptionOrderByInput = {
  field?: InputMaybe<SubscriptionOrderAllowedFields>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type SubscriptionOutput = {
  __typename?: 'SubscriptionOutput';
  boxes: Array<BoxOutput>;
  cancellation?: Maybe<CancellationOutput>;
  comments: Array<CommentOutput>;
  conditions: ConditionsOutput;
  conditionsSwitches: Array<ConditionsSwitchOutput>;
  createdAt: Scalars['DateTime']['output'];
  customer: PersonOutput;
  device?: Maybe<DeviceOutput>;
  deviceChanges: Array<DeviceChangeOutput>;
  displayStatus: SubscriptionDisplayStatus;
  grandpaNickname?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  order: OrderOutput;
  payment: PaymentOutput;
  portabilities: Array<PortabilityOutput>;
  shipments: Array<ShipmentOutput>;
  sim?: Maybe<SimOutput>;
  simChanges: Array<SimChangeOutput>;
  status: SubscriptionStatus;
  tickets: Array<TicketOutput>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SubscriptionPaginatedOutput = {
  __typename?: 'SubscriptionPaginatedOutput';
  total: Scalars['Float']['output'];
  values: Array<SubscriptionOutput>;
};

export enum SubscriptionStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  PENDING = 'PENDING'
}

export type SubscriptionsStatsOutput = {
  __typename?: 'SubscriptionsStatsOutput';
  averageLifetimeDays: Scalars['Float']['output'];
  churn: Scalars['Float']['output'];
  conditions: Scalars['JSON']['output'];
  net: Scalars['Float']['output'];
  total: Scalars['JSON']['output'];
};

export enum SuspicionField {
  ADDRESS = 'ADDRESS',
  DOCUMENT_NUMBER = 'DOCUMENT_NUMBER',
  EMAIL = 'EMAIL',
  NAME = 'NAME',
  PHONE = 'PHONE'
}

export type SuspicionIssueOutput = {
  __typename?: 'SuspicionIssueOutput';
  kind: OrderHoldIssueKind;
  matches: Array<SuspicionMatchOutput>;
};

export type SuspicionMatchOutput = {
  __typename?: 'SuspicionMatchOutput';
  commonSubstring?: Maybe<Scalars['String']['output']>;
  documentNumber: Scalars['String']['output'];
  field: SuspicionField;
  inputValue: Scalars['String']['output'];
  matchedValue: Scalars['String']['output'];
  similarity: Scalars['Float']['output'];
  source: SuspicionSource;
  sourceId: Scalars['String']['output'];
};

export enum SuspicionSource {
  FRAUD_PROFILE = 'FRAUD_PROFILE',
  UNPAID_CUSTOMER = 'UNPAID_CUSTOMER'
}

export type SwitchConditionsInput = {
  conditionsId: ConditionsIdInput;
  removedSimAction?: InputMaybe<RemovedSimAction>;
  subscriptionId: SubscriptionIdInput;
};

export type TicketOpenerOutput = {
  __typename?: 'TicketOpenerOutput';
  avatarURL?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type TicketOutput = {
  __typename?: 'TicketOutput';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  lastUpdated: Scalars['DateTime']['output'];
  opener?: Maybe<TicketOpenerOutput>;
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type TrackingCodeInput = {
  value: Scalars['String']['input'];
};

export type UnassignExternalAppInput = {
  grandpaUUID: GrandpaUuidInput;
  packageName: PackageNameInput;
};

export type UnexpectedErrorIssueOutput = {
  __typename?: 'UnexpectedErrorIssueOutput';
  errorCode: Scalars['String']['output'];
  kind: OrderHoldIssueKind;
  message: Scalars['String']['output'];
};

export type UpdateAppInput = {
  imei: DeviceImeiInput;
  packageName: Scalars['String']['input'];
};

export type UpdateAppOutput = {
  __typename?: 'UpdateAppOutput';
  currentVersionCode?: Maybe<Scalars['Float']['output']>;
  intendedVersionCode: Scalars['Float']['output'];
  isUpdated: Scalars['Boolean']['output'];
  packageName: Scalars['String']['output'];
};

export type UpdateExternalAppInput = {
  iconPath?: InputMaybe<Scalars['String']['input']>;
  isDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  isShared?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  packageName: PackageNameInput;
  subtitle?: InputMaybe<Scalars['String']['input']>;
};

export type UploadExternalAppIconInput = {
  fileBase64: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UserAccessGrantInput = {
  accessLevel: AccessLevel;
  grandpaUUID: GrandpaUuidInput;
  userPhoneNumber: PhoneNumberInput;
};

export type UserAccessRemovalInput = {
  grandpaUUID: GrandpaUuidInput;
  userPhoneNumber: PhoneNumberInput;
};

export enum VoicemailStatus {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED'
}
